// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pcc-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
}

.pcc-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pcc-header h2 {
  margin: 0;
  font-size: 1.4rem;
  color: #222;
}

.pcc-subtitle {
  margin: 6px 0 0;
  color: #555;
  line-height: 1.35;
  font-size: 0.95rem;
}

.pcc-controls {
  display: grid;
  grid-template-columns: 90px minmax(160px, 280px) 130px 1fr;
  gap: 10px;
  align-items: center;
}

.pcc-label {
  color: #333;
  font-weight: 600;
}

.pcc-input {
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid #cfcfcf;
  border-radius: 8px;
  text-transform: uppercase;
  font-size: 0.95rem;
  box-sizing: border-box;
}

.pcc-btn {
  min-height: 38px;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  background: #667eea;
  color: #fff;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
}

.pcc-btn:hover:not(:disabled) {
  background: #5568d3;
}

.pcc-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pcc-meta {
  color: #444;
  font-size: 0.95rem;
}

.pcc-card {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 14px;
}

.pcc-error {
  border-color: #f2b8b8;
  background: #fff5f5;
  color: #8a1f1f;
}

.pcc-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
  color: #333;
}

.pcc-empty {
  padding: 10px 0;
  color: #666;
}

.pcc-table-wrap {
  overflow-x: auto;
}

.pcc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;
}

.pcc-table th,
.pcc-table td {
  border: 1px solid #e6e6e6;
  padding: 8px 10px;
  text-align: left;
  white-space: nowrap;
}

.pcc-table th {
  background: #f4f4f4;
  font-weight: 700;
}

.pcc-th-strong {
  background: #f0f2ff;
}

.pcc-strong {
  font-weight: 700;
}

.pcc-protection-ok {
  color: #135d2f;
}

.pcc-protection-risk {
  color: #8a1f1f;
}

.pcc-row-best td {
  background: #f0fff6;
}

.pcc-explain {
  margin: 10px 0 14px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fcfcfc;
}

.pcc-explain-summary {
  cursor: pointer;
  font-weight: 800;
  color: #222;
}

.pcc-explain-body {
  margin-top: 10px;
  color: #333;
}

.pcc-explain-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 12px;
}

.pcc-explain-block {
  border: 1px solid #ededed;
  background: #fff;
  border-radius: 10px;
  padding: 12px;
}

.pcc-explain-title {
  font-weight: 900;
  margin-bottom: 6px;
}

.pcc-explain-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
  line-height: 1.35;
  font-size: 0.95rem;
}

.pcc-formula {
  margin-top: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  background: #f6f6f6;
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 8px 10px;
  color: #111;
  overflow-x: auto;
}

@media (max-width: 860px) {
  .pcc-controls {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
  .pcc-meta {
    margin-top: 2px;
  }
  .pcc-explain-grid {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/ProtectiveCoveredCall.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+GAA+G;EAC/G,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".pcc-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 16px;\n}\n\n.pcc-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.pcc-header h2 {\n  margin: 0;\n  font-size: 1.4rem;\n  color: #222;\n}\n\n.pcc-subtitle {\n  margin: 6px 0 0;\n  color: #555;\n  line-height: 1.35;\n  font-size: 0.95rem;\n}\n\n.pcc-controls {\n  display: grid;\n  grid-template-columns: 90px minmax(160px, 280px) 130px 1fr;\n  gap: 10px;\n  align-items: center;\n}\n\n.pcc-label {\n  color: #333;\n  font-weight: 600;\n}\n\n.pcc-input {\n  min-height: 38px;\n  padding: 8px 10px;\n  border: 1px solid #cfcfcf;\n  border-radius: 8px;\n  text-transform: uppercase;\n  font-size: 0.95rem;\n  box-sizing: border-box;\n}\n\n.pcc-btn {\n  min-height: 38px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: none;\n  background: #667eea;\n  color: #fff;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.pcc-btn:hover:not(:disabled) {\n  background: #5568d3;\n}\n\n.pcc-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.pcc-meta {\n  color: #444;\n  font-size: 0.95rem;\n}\n\n.pcc-card {\n  background: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 10px;\n  padding: 14px;\n}\n\n.pcc-error {\n  border-color: #f2b8b8;\n  background: #fff5f5;\n  color: #8a1f1f;\n}\n\n.pcc-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 12px;\n  color: #333;\n}\n\n.pcc-empty {\n  padding: 10px 0;\n  color: #666;\n}\n\n.pcc-table-wrap {\n  overflow-x: auto;\n}\n\n.pcc-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.92rem;\n}\n\n.pcc-table th,\n.pcc-table td {\n  border: 1px solid #e6e6e6;\n  padding: 8px 10px;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.pcc-table th {\n  background: #f4f4f4;\n  font-weight: 700;\n}\n\n.pcc-th-strong {\n  background: #f0f2ff;\n}\n\n.pcc-strong {\n  font-weight: 700;\n}\n\n.pcc-protection-ok {\n  color: #135d2f;\n}\n\n.pcc-protection-risk {\n  color: #8a1f1f;\n}\n\n.pcc-row-best td {\n  background: #f0fff6;\n}\n\n.pcc-explain {\n  margin: 10px 0 14px;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  padding: 10px 12px;\n  background: #fcfcfc;\n}\n\n.pcc-explain-summary {\n  cursor: pointer;\n  font-weight: 800;\n  color: #222;\n}\n\n.pcc-explain-body {\n  margin-top: 10px;\n  color: #333;\n}\n\n.pcc-explain-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(260px, 1fr));\n  gap: 12px;\n}\n\n.pcc-explain-block {\n  border: 1px solid #ededed;\n  background: #fff;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.pcc-explain-title {\n  font-weight: 900;\n  margin-bottom: 6px;\n}\n\n.pcc-explain-text {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  line-height: 1.35;\n  font-size: 0.95rem;\n}\n\n.pcc-formula {\n  margin-top: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  background: #f6f6f6;\n  border: 1px solid #ececec;\n  border-radius: 8px;\n  padding: 8px 10px;\n  color: #111;\n  overflow-x: auto;\n}\n\n@media (max-width: 860px) {\n  .pcc-controls {\n    grid-template-columns: 1fr;\n    align-items: stretch;\n  }\n  .pcc-meta {\n    margin-top: 2px;\n  }\n  .pcc-explain-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
